import React from "react";
import PropTypes from "prop-types";
import { Stack } from "@mui/material";
import Markdown from "@/components/Markdown";
import PageContainer from "@/components/pages/COA/PageContainer";
import Title1 from "@/components/pages/COA/Title1";
import Description from "@/components/pages/COA/Description";

const Hero = ({ styles, hero }) => (
  <Stack
    sx={{
      backgroundImage: `url(${hero.backgroundImage.publicURL})`,
      backgroundSize: "cover",
      backgroundPosition: "center left",
      backgroundRepeat: "no-repeat",
      padding: "60px 0 60px",
      color: "white",
      marginBottom: 0
    }}
  >
    <PageContainer className={styles.heroContainer}>
      <div className={styles.heroLogo}>
        {hero.ctaLogo && (
          <img
            src={hero.ctaLogo.publicURL}
            alt={hero.ctaLogoAltText}
            className={styles.ctaLogo}
          />
        )}
      </div>
      <div className={styles.heroContent}>
        <Title1>{hero.title}</Title1>
        <Description white>{hero.description}</Description>
        <a href={hero.ctaLink} className={styles.heroButton}>
          <Markdown>{hero.ctaText}</Markdown>
          <span style={{ marginLeft: "16px" }}>
            <i className="fa fa-chevron-right" aria-hidden="true" />
          </span>
        </a>
        <hr className={styles.separator} />
      </div>
    </PageContainer>
  </Stack>
);

Hero.propTypes = {
  styles: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  hero: PropTypes.shape({
    backgroundImage: PropTypes.shape({
      publicURL: PropTypes.string.isRequired
    }).isRequired,
    ctaLogo: PropTypes.shape({
      publicURL: PropTypes.string.isRequired
    }).isRequired,
    ctaLogoAltText: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    ctaLink: PropTypes.string.isRequired,
    ctaText: PropTypes.string.isRequired
  }).isRequired
};

export default Hero;
